/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var creditLimit = "";
  var totalBalance = "";
  var outstanding = "";
  var mto = "";
  var mt = "";
  var sales = "";
  var comm = "";
  var earn = "";
  var strike = "";
  var win = "";
  var total = "";
  var company = "";
  var downline = "";

  var neg = function neg(text) {
    var txt = text;

    if (text.includes("-")) {
      txt = "<span style=\"color:red\">" + text + "</span>";
    }

    return txt;
  };

  var search = function search() {
    $f7.request({
      method: 'get',
      url: window.waypoint + 'report.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        drawDateFrom: $("#drawDateFrom").val(),
        drawDateTo: $("#drawDateTo").val()
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        var data = JSON.parse(data);
        creditLimit = data.creditLimit;
        totalBalance = data.totalBalance;
        outstanding = neg(data.outstanding);
        mto = neg(data.MTO);
        mt = neg(data.MT);
        sales = neg(data.sales);
        comm = neg(data.comm);
        earn = neg(data.earn);
        strike = neg(data.strike);
        win = neg(data.win);
        total = neg(data.total);
        company = "";
        downline = "";

        for (var i = 0; i < data.company.length; i++) {
          company += "\n          <div class=\"card data-table\">\n            <table>\n              <tbody>\n                <tr><td class=\"label-cell\">\n                  <span class='en'>Sales</span>\n                  <span class='cn'>\u9500\u552E\u91CF</span>\n                  <span class='tl'>Faan</span>\n                </td><td class=\"numeric-cell\">" + neg(data.company[i].sales) + "</td></tr>\n                <tr><td class=\"label-cell\">\n                  <span class='en'>Commission</span>\n                  <span class='cn'>\u4F63\u91D1</span>\n                  <span class='tl'>Komisaun</span>\n                </td><td class=\"numeric-cell\">" + neg(data.company[i].comm) + "</td></tr>\n                <tr><td class=\"label-cell\">\n                  <span class='en'>Strike</span>\n                  <span class='cn'>\u4E2D</span>\n                  <span class='tl'>Kona</span>\n                </td><td class=\"numeric-cell\">" + neg(data.company[i].strike) + "</td></tr>\n                <tr><td class=\"label-cell\">Total</td><td class=\"numeric-cell\">" + neg(data.company[i].total) + "</td></tr>\n              </tbody>\n            </table>\n          </div>\n          ";
        }

        for (var i = 0; i < data.downlines.length; i++) {
          downline += "\n          <div class=\"card data-table\">\n            <table>\n              <tbody>\n                <tr><td class=\"label-cell\">\n                  <span class='en'>Login ID</span>\n                  <span class='cn'>\u767B\u5F55ID</span>\n                  <span class='tl'>Kode ID</span>\n                </td><td class=\"numeric-cell\">" + data.downlines[i].loginID + "</td></tr>\n                <tr><td class=\"label-cell\">\n                  <span class='en'>Sales</span>\n                  <span class='cn'>\u9500\u552E\u91CF</span>\n                  <span class='tl'>Faan</span>\n                </td><td class=\"numeric-cell\">" + neg(data.downlines[i].sales) + "</td></tr>\n                <tr><td class=\"label-cell\">\n                  <span class='en'>Commission</span>\n                  <span class='cn'>\u4F63\u91D1</span>\n                  <span class='tl'>Komisaun</span>\n                </td><td class=\"numeric-cell\">" + neg(data.downlines[i].comm) + "</td></tr>\n                <tr><td class=\"label-cell\">\n                  <span class='en'>Strike</span>\n                  <span class='cn'>\u4E2D</span>\n                  <span class='tl'>Kona</span>\n                </td><td class=\"numeric-cell\">" + neg(data.downlines[i].strike) + "</td></tr>\n                <tr><td class=\"label-cell\">Total</td><td class=\"numeric-cell\">" + neg(data.downlines[i].total) + "</td></tr>\n              </tbody>\n            </table>\n          </div>\n          ";
        }

        $update();
      }
    });
  };

  $on('pageInit', function () {
    document.getElementById('drawDateFrom').valueAsDate = new Date();
    document.getElementById('drawDateTo').valueAsDate = new Date();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">
            <span class='en'>Back</span>
            <span class='cn'>返回</span>
            <span class='tl'>Fila</span>
          </span>
        </a>
      </div>
      <div class="title">
        <span class='en'>Win and Lose Report</span>
        <span class='cn'>输赢报告</span>
        <span class='tl'>Manán no lakon relatóriu</span>
      </div>
    </div>
  </div>
  <div class="page-content">
  
    <div class="block">
      
        <span class='en'>Please select the FROM and TO date to show the report.</span>
        <span class='cn'></span>
        <span class='tl'>Favor hili data husi komesa to data remata nebe ita taru atu nune bele hatudu ita nia relatoriu</span>
      
    </div>

    <div class="block-title">
      <span class='en'>Bet Date</span>
      <span class='cn'>投注日期</span>
      <span class='tl'>Data Joga</span>
    </div>
    <div class="list  inline-labels inset">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>From</span>
              <span class='cn'>开始</span>
              <span class='tl'>Husi</span>
            </div>
            <div class="item-input-wrap">
              <input type="date" value="2014-04-30" placeholder="Please choose..." id="drawDateFrom" />
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>To</span>
              <span class='cn'>结束</span>
              <span class='tl'>Ba</span>
            </div>
            <div class="item-input-wrap">
              <input type="date" value="2014-04-30" placeholder="Please choose..." id="drawDateTo"/>
            </div>
          </div>
        </li>       
        <li>
          <p class="segmented">
            <button class="button"></button>
            <button class="button"></button>
            <button class="button button-fill button-active" @click=${search}>
              <span class='en'>Search</span>
              <span class='cn'>搜索</span>
              <span class='tl'>Buka</span>
            </button>
            <span class="segmented-highlight"></span>
          </p>
        </li>
      </ul>
    </div>


    <div class="block-title">
      <span class='en'>Search Result</span>
      <span class='cn'>搜索结果</span>
      <span class='tl'>Buka rezultado</span>
    </div>
    <div class="card data-table">
      <table>
        <tbody>
          <tr><td class="label-cell">
            <span class='en'>Credit Limit</span>
            <span class='cn'>信用额度</span>
            <span class='tl'>Limitasaun ba kreditu</span>
          </td><td class="numeric-cell" innerHTML=${creditLimit}></td></tr>
          <tr><td class="label-cell">
            <span class='en'>Total Balance</span>
            <span class='cn'>总余额</span>
            <span class='tl'>Total balansu</span>
          </td><td class="numeric-cell" innerHTML=${totalBalance}></td></tr>
          <tr><td class="label-cell">
            <span class='en'>Outstanding</span>
            <span class='cn'>未完成交易</span>
            <span class='tl'>Sei adia fali</span>
          </td><td class="numeric-cell" innerHTML=${outstanding}></td></tr>
          <tr><td class="label-cell">
            <span class='en'>Member Turn Over</span>
            <span class='cn'>会员营业额</span>
            <span class='tl'>Membru nia tempu hotu</span>
          </td><td class="numeric-cell" innerHTML=${mto}></td></tr>
          <tr style="display: none;"><td class="label-cell">
            <span class='en'>Turn Over</span>
            <span class='cn'>营业额</span>
            <span class='tl'>Tempu hotu</span>
          </td><td class="numeric-cell" innerHTML=${mt}></td></tr>
          <tr><td class="label-cell">
            <span class='en'>Sales</span>
            <span class='cn'>销售量</span>
            <span class='tl'>Faan</span>
          </td><td class="numeric-cell" innerHTML=${sales}></td></tr> 
          <tr><td class="label-cell">
            <span class='en'>Commission</span>
            <span class='cn'>佣金</span>
            <span class='tl'>Komisaun</span>
          </td><td class="numeric-cell" innerHTML=${comm}></td></tr>
          <tr style="display: none;"><td class="label-cell">
            <span class='en'>Earning</span>
            <span class='cn'>收入</span>
            <span class='tl'>Osan tama</span>
          </td><td class="numeric-cell" innerHTML=${earn}></td></tr>
          <tr><td class="label-cell">
            <span class='en'>Strike</span>
            <span class='cn'>中</span>
            <span class='tl'>Kona</span>
          </td><td class="numeric-cell" innerHTML=${strike}></td></tr>
          <tr><td class="label-cell">
            <span class='en'>Win</span>
            <span class='cn'>赢</span>
            <span class='tl'>Manan</span>
          </td><td class="numeric-cell" innerHTML=${win}></td></tr>
          <tr><td class="label-cell">
            <span class='en'>Total</span>
            <span class='cn'>全部的</span>
            <span class='tl'>Totalidade</span>
          </td><td class="numeric-cell" innerHTML=${total}></td></tr>
        </tbody>
      </table>
    </div>

    <div class="block-title" style="display: none;">
      <span class='en'>Company</span>
      <span class='cn'>公司</span>
      <span class='tl'>Kompanya</span>
    </div>
    <div innerHTML=${company} style="display: none;">
    </div>

    <div class="block-title" style="display: none;">
      <span class='en'>Downlines</span>
      <span class='cn'>下线</span>
      <span class='tl'>Linha tun</span>
    </div>
    <div innerHTML=${downline} style="display: none;">
    </div>

    
    
    

  </div>
</div>
`
    }
    ;
}

framework7Component.id = '1e0b2e7008';
export default framework7Component;